import React from "react";
import ReactDOM from "react-dom";

class BaseDialog extends React.Component {
    /**
     * Base class of popup dialog
     * @module BaseDialog
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.closeHandle = this.handleClose.bind(this);
    }

    /**
     * Get reference to dialog container itself
     * @returns {jQuery}
     */
    getDomSelf(){
        return $(ReactDOM.findDOMNode(this));
    }

    componentDidMount(){
        this._isMounted = true;
        document.addEventListener("ev-dialog-close", this.closeHandle);
        // auto focus on first focusable element
        this.getDomSelf().find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).trigger("focus");
    }

    componentWillUnmount(){
        this._isMounted = false;
        document.removeEventListener("ev-dialog-close", this.closeHandle);
        this.unregister();
    }

    /**
     * Handle dialog closing event
     */
    handleClose(){
        // unmount react component on close
        if (this._isMounted) {
            try{
                const parentDom = ReactDOM.findDOMNode(this).parentNode;
                if (parentDom) {
                    ReactDOM.unmountComponentAtNode(parentDom);
                }
            } catch(e){
                
            }            
        }
    }

    /**
     * Remove document event listeners here
     */
    unregister(){

    }
}

export default BaseDialog;
